export const Document = (documents = {}) => {
  const rawItems = [
    ["PAN Document", documents.PANFile || "-"],
    ["GST Certificate", documents.GSTFile || "-"],
    ["Cancelled Cheque", documents.CancelledCheque || "-"],
    ["FSSAI Certificate", documents.FSSAICertificate || "-"],
    ["MSME Document", documents.MSMEDocument || "-"],
    ["Organic Category", documents.OrganicCategory || "-"],
    ["Diabetic Category", documents.DiabeticCategory || "-"],
    ["VAT / TIN / CST Number", documents.VATTINCSTNumber || "-"],
    ["RTGS Details", documents.RTGSDetails || "-"],
    ["Business Code Of Conduct", documents.BusinessCodeOfConduct || "-"],
    ["Article Of Association", documents.ArticalOfAssociation || "-"],
    ["Partnership Deed", documents.PartnershipDeed || "-"],
  ];

  if (rawItems.length === 0) {
    return `
      <h5>Document</h5>
      <p>No documents available</p>
    `;
  }

  const rows = [];
  for (let i = 0; i < rawItems.length; i += 2) {
    rows.push(rawItems.slice(i, i + 2));
  }

  return `
<h5>Document</h5>

<style>
  .doc-table {
    width: 100%;
    border-collapse: collapse;
    page-break-inside: auto;
  }
  .doc-table tr {
    page-break-inside: avoid;
    break-inside: avoid;
  }
  .doc-table td {
    border: 1px solid #000;
    padding: 6px;
    vertical-align: top;
    page-break-inside: avoid;
    break-inside: avoid;
  }
  .doc-table td div {
    page-break-inside: avoid;
    break-inside: avoid;
  }
  .lbl {
    font-weight: 600;
    white-space: nowrap;
  }
</style>

<table class="doc-table">
  ${rows
    .map(
      (row) => `
      <tr>
        ${row
          .map(
            ([label, value]) => `
            <td class="lbl"><div>${label}</div></td>
            <td><div>${value}</div></td>
          `
          )
          .join("")}
      </tr>
    `
    )
    .join("")}
</table>
`;
};